var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTestopsReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-Invite-users-to-your-organization",
    transform: "translate(-653.000000, -607.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-testops-report",
    transform: "translate(653.000000, 607.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#57CFFF",
    points: "-1.42108547e-14 35 17.4816749 35 14.3714453 32.5175667 34.2737617 2.48689958e-14 -1.42108547e-14 2.48689958e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#4D94FF",
    points: "34.2737617 35 13.3886719 35 6.26621503 23.2356187 20.2103579 11.875"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 14.5,
    cy: 17.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.86,22 L11.86,15.64 L14.2,15.64 L14.2,13.6 L7.24,13.6 L7.24,15.64 L9.58,15.64 L9.58,22 L11.86,22 Z M17.68,22 L17.68,19.36 L18.88,19.36 L20.32,22 L22.72,22 L20.98,18.94 C21.252,18.804 21.492,18.62 21.7,18.388 C21.884,18.196 22.05,17.944 22.198,17.632 C22.346,17.32 22.42,16.936 22.42,16.48 C22.42,16.072 22.344,15.694 22.192,15.346 C22.04,14.998 21.83,14.694 21.562,14.434 C21.294,14.174 20.972,13.97 20.596,13.822 C20.22,13.674 19.808,13.6 19.36,13.6 L19.36,13.6 L15.4,13.6 L15.4,22 L17.68,22 Z M19.24,17.32 L17.68,17.32 L17.68,15.64 L19.24,15.64 C19.512,15.64 19.73,15.72 19.894,15.88 C20.058,16.04 20.14,16.24 20.14,16.48 C20.14,16.72 20.058,16.92 19.894,17.08 C19.73,17.24 19.512,17.32 19.24,17.32 L19.24,17.32 Z",
    id: "TR",
    fill: "#4D94FF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTestopsReport);
export default __webpack_public_path__ + "static/media/logo_testops_report.741b2eaa9dbdb018e80c3860fffffc00.svg";
export { ForwardRef as ReactComponent };